module.exports = __webpack_public_path__ + "static/delivery-44ac65ffbed067f7f92e62b2ffb73275.jpeg";